import {
  IstitutionActionTypes,
  PortalActionTypes,
  ContactActionTypes,
  OrganizationTypes,
  ReminderTypes,
  ScheduleEmailReportTypes,
  OrganizationBranchesTypes
} from './types';

export const getInstitution = (payload) => ({
  type: IstitutionActionTypes.GET_INSTITUTION,
  payload,
});

export const getInstitutionSuccess = (payload) => ({
  type: IstitutionActionTypes.GET_INSTITUTION_SUCCESS,
  payload,
});

export const getInstitutionFailed = (payload) => ({
  type: IstitutionActionTypes.GET_INSTITUTION_FAILED,
  payload,
});

export const addInstitution = (orgId, formData, updateAlias=false) => ({
  type: IstitutionActionTypes.ADD_INSTITUTION,
  data: { orgId, formData, updateAlias },
});

export const addInstitutionSuccess = (payload) => ({
  type: IstitutionActionTypes.ADD_INSTITUTION_SUCCESS,
  payload,
});

export const addInstitutionAliasSuccess = (payload) => ({
  type: IstitutionActionTypes.ADD_INSTITUTION_ALIAS_SUCCESS,
  payload,
});

export const addInstitutionFailed = (payload) => ({
  type: IstitutionActionTypes.ADD_INSTITUTION_FAILED,
  payload,
});

export const updateInstitution = (payload) => ({
  type: IstitutionActionTypes.UPDATE_INSTITUTION,
  data: { payload },
});
export const updateInstitutionSuccess = (payload) => ({
  type: IstitutionActionTypes.UPDATE_INSTITUTION_SUCCESS,
  payload,
});

export const updateInstitutionFailed = (payload) => ({
  type: IstitutionActionTypes.UPDATE_INSTITUTION_FAILED,
  payload,
});

export const deleteInstitution = (payload) => ({
  type: IstitutionActionTypes.DELETE_INSTITUTION,
  data: { payload },
});

export const deleteInstitutionSuccess = () => ({
  type: IstitutionActionTypes.DELETE_INSTITUTION_SUCCESS,
});

export const deleteInstitutionFailed = (payload) => ({
  type: IstitutionActionTypes.DELETE_INSTITUTION_FAILED,
  payload,
});

export const setPortalCurrent = (settings) => ({
  type: PortalActionTypes.SET_CURRENT_SETTINGS,
  payload: settings,
});
export const clearPortalCurrent = () => ({
  type: PortalActionTypes.CLEAR_CURRENT_SETTINGS,
});

// portal settings

export const getPortal = (pageNumber) => ({
  type: PortalActionTypes.GET_PORTAL,
  data: { pageNumber },
});

export const getPortalSuccess = (payload) => ({
  type: PortalActionTypes.GET_PORTAL_SUCCESS,
  payload,
});

export const getPortalFailed = (payload) => ({
  type: PortalActionTypes.GET_PORTAL_FAILED,
  payload,
});

export const addPortal = (orgId, formData) => ({
  type: PortalActionTypes.ADD_PORTAL,
  data: { orgId, formData },
});

export const addPortalSuccess = (payload) => ({
  type: PortalActionTypes.ADD_PORTAL_SUCCESS,
  payload,
});

export const addPortalFailed = (payload) => ({
  type: PortalActionTypes.ADD_PORTAL_FAILED,
  payload,
});

export const updatePortal = (payload) => ({
  type: PortalActionTypes.UPDATE_PORTAL,
  data: { payload },
});
export const updatePortalSuccess = (payload) => ({
  type: PortalActionTypes.UPDATE_PORTAL_SUCCESS,
  payload,
});

export const updatePortalFailed = (payload) => ({
  type: PortalActionTypes.UPDATE_INSTITUTION_FAILED,
  payload,
});

export const deletePortal = (payload) => ({
  type: PortalActionTypes.DELETE_PORTAL,
  data: { payload },
});

export const deletePortalSuccess = () => ({
  type: PortalActionTypes.DELETE_PORTAL_SUCCESS,
});

export const deletePortalFailed = (payload) => ({
  type: PortalActionTypes.DELETE_PORTAL_FAILED,
  payload,
});

// contact info
export const saveContact = (payload) => ({
  type: ContactActionTypes.SAVE_CONTACT,
  data: payload,
});

export const saveContactFailed = (payload) => ({
  type: ContactActionTypes.SAVE_CONTACT_FAILED,
  payload,
});

// check org
export const checkOrg = (id, cb) => ({
  type: OrganizationTypes.CHECK_ORG_EXISTS,
  data: { id, cb },
});

export const checkOrgSuccess = () => ({
  type: OrganizationTypes.CHECK_ORG_EXISTS_SUCCESS,
});

export const checkOrgFailed = (payload) => ({
  type: OrganizationTypes.CHECK_ORG_EXISTS_FAILED,
  payload,
});


// reminders
export const saveReminder = (data, cb) => ({
  type: ReminderTypes.SAVING_REMINDER_SETTINGS,
  payload:{data, cb},
});

export const saveReminderSuccess = (payload) => ({
  type: ReminderTypes.SAVING_REMINDER_SETTINGS_SUCCESS,
  payload
});

export const saveReminderFailed = (payload) => ({
  type: ReminderTypes.SAVING_REMINDER_SETTINGS_FAILED,
  payload,
});

export const editReminder = (data, cb) => ({
  type: ReminderTypes.EDITING_REMINDER_SETTINGS,
  payload:{data, cb},
});

export const editReminderSuccess = (payload) => ({
  type: ReminderTypes.EDITING_REMINDER_SETTINGS_SUCCESS,
  payload
});

export const editReminderFailed = (payload) => ({
  type: ReminderTypes.EDITING_REMINDER_SETTINGS_FAILED,
  payload,
});

export const deleteReminder = (id, cb) => ({
  type: ReminderTypes.DELETING_REMINDER_SETTINGS,
  payload: {id, cb},
});

export const deleteReminderSuccess = (payload) => ({
  type: ReminderTypes.DELETING_REMINDER_SETTINGS_SUCCESS,
  payload
});

export const deleteReminderFailed = (payload) => ({
  type: ReminderTypes.DELETING_REMINDER_SETTINGS_FAILED,
  payload,
});

export const fetchReminder = (data) => ({
  type: ReminderTypes.FETCHING_REMINDER_SETTINGS,
  data,
});

export const fetchReminderSuccess = (data) => ({
  type: ReminderTypes.FETCHING_REMINDER_SETTINGS_SUCCESS,
  payload: data
});

export const fetchReminderFailed = (payload) => ({
  type: ReminderTypes.FETCHING_REMINDER_SETTINGS_FAILED,
  payload,
});


// email report settings
export const fetchSchedule = (data) => ({
  type: ScheduleEmailReportTypes.FETCHING_EMAIL_SCHEDULE_SETTINGS,
  data,
});

export const fetchScheduleSuccess = (data) => ({
  type: ScheduleEmailReportTypes.FETCHING_EMAIL_SCHEDULE_SETTINGS_SUCCESS,
  payload: data
});

export const fetchScheduleFailed = (payload) => ({
  type: ScheduleEmailReportTypes.FETCHING_EMAIL_SCHEDULE_SETTINGS_FAILED,
  payload,
});

export const deleteSchedule = (id, cb) => ({
  type: ScheduleEmailReportTypes.DELETING_EMAIL_SCHEDULE_SETTINGS,
  payload: {id, cb},
});

export const deleteScheduleSuccess = (payload) => ({
  type: ScheduleEmailReportTypes.DELETING_EMAIL_SCHEDULE_SETTINGS_SUCCESS,
  payload
});

export const deleteScheduleFailed = (payload) => ({
  type: ScheduleEmailReportTypes.DELETING_EMAIL_SCHEDULE_SETTINGS_FAILED,
  payload,
});

// Edit Schedule Email

export const editSchedule = (data, cb) => ({
  type: ScheduleEmailReportTypes.EDITING_EMAIL_SCHEDULE_SETTINGS,
  payload: {data, cb},
});

export const editScheduleSuccess = (payload) => ({
  type: ScheduleEmailReportTypes.EDITING_EMAIL_SCHEDULE_SETTINGS_SUCCESS,
  payload
});

export const editScheduleFailed = (payload) => ({
  type: ScheduleEmailReportTypes.EDITING_EMAIL_SCHEDULE_SETTINGS_FAILED,
  payload,
});

// org branches
export const saveOrgBranch = (data, cb) => ({
  type: OrganizationBranchesTypes.SAVING_ORG_BRANCH,
  payload:{data, cb},
});

export const saveOrgBranchSuccess = (payload) => ({
  type: OrganizationBranchesTypes.SAVING_ORG_BRANCH_SUCCESS,
  payload
});

export const saveOrgBranchFailed = (payload) => ({
  type: OrganizationBranchesTypes.SAVING_ORG_BRANCH_FAILED,
  payload,
});

export const editOrgBranch = (data, cb) => ({
  type: OrganizationBranchesTypes.EDITING_ORG_BRANCH,
  payload:{data, cb},
});

export const editOrgBranchSuccess = (payload) => ({
  type: OrganizationBranchesTypes.EDITING_ORG_BRANCH_SUCCESS,
  payload
});

export const editOrgBranchFailed = (payload) => ({
  type: OrganizationBranchesTypes.EDITING_ORG_BRANCH_FAILED,
  payload,
});

export const deleteOrgBranch = (id, cb) => ({
  type: OrganizationBranchesTypes.DELETING_ORG_BRANCH,
  payload: {id, cb},
});

export const deleteOrgBranchSuccess = (payload) => ({
  type: OrganizationBranchesTypes.DELETING_ORG_BRANCH_SUCCESS,
  payload
});

export const deleteOrgBranchFailed = (payload) => ({
  type: OrganizationBranchesTypes.DELETING_ORG_BRANCH_FAILED,
  payload,
});

export const fetchOrgBranches = (data) => ({
  type: OrganizationBranchesTypes.FETCHING_ORG_BRANCHES,
  data,
});

export const fetchOrgBranchesSuccess = (data) => ({
  type: OrganizationBranchesTypes.FETCHING_ORG_BRANCHES_SUCCESS,
  payload: data
});

export const fetchOrgBranchesFailed = (payload) => ({
  type: OrganizationBranchesTypes.FETCHING_ORG_BRANCHES_FAILED,
  payload,
});